import { put } from "redux-saga/effects";
import { fingerPrintMatchByCard } from "../../Services";

export function* FingerPrintMatchByCard(action) {
  const payload = action.payload;
  try {
    const res = yield fingerPrintMatchByCard(payload);

    yield put({ type: "REQ_MATCH_FINGERPRINT_CARD_SUCCEEDED", data: res.data });
  } catch (e) {
    yield put({ type: "REQ_MATCH_FINGERPRINT_CARD_FAILED", errData: e });
  }
}
